import api, { BASE_URL } from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    fr?: string
    es?: string
    ru?: string
    nl?: string
    ar?: string
}

export interface Certificate {
    _id?: string
    title: LocalizedString
    subtitle: LocalizedString
    description: LocalizedString
    imageUrl?: string
    fileUrl?: string
    orderIndex?: number
}

export interface CertificatePage {
    _id?: string
    hero: {
        title: LocalizedString
        subtitle: LocalizedString
    }
    certificates: Certificate[]
}

export const certificateService = {
    getCertificatePage: async () => {
        const res = await api.get<CertificatePage>('/certificate-page')
        const data = res.data
        if (data && data.certificates) {
            data.certificates = data.certificates.map(c => ({
                ...c,
                imageUrl: c.imageUrl?.startsWith('/') ? `${BASE_URL}${c.imageUrl}` : c.imageUrl,
                fileUrl: c.fileUrl?.startsWith('/') ? `${BASE_URL}${c.fileUrl}` : c.fileUrl
            }))
        }
        return data
    },
    updateCertificatePage: async (data: Partial<CertificatePage>, translate: boolean = false) => {
        const res = await api.put<CertificatePage>('/certificate-page', data, { params: { translate } })
        return res.data
    },
    uploadCertificateAsset: async (file: File) => {
        const formData = new FormData()
        formData.append('photo', file)
        const res = await api.post<{ photo: { url: string } }>('/upload/team-photo', formData) // Reusing existing upload endpoint
        return {
            ...res.data,
            photo: {
                ...res.data.photo,
                url: res.data.photo.url?.startsWith('/') ? `${BASE_URL}${res.data.photo.url}` : res.data.photo.url
            }
        }
    }
}
